import api from '../../api/axios';
import { showError, showSuccess } from '../../Components/reuse/Toast';

// Action Types: Users dropdown
export const GET_USERS_DROPDOWN_REQUEST = 'GET_USERS_DROPDOWN_REQUEST';
export const GET_USERS_DROPDOWN_SUCCESS = 'GET_USERS_DROPDOWN_SUCCESS';
export const GET_USERS_DROPDOWN_FAILURE = 'GET_USERS_DROPDOWN_FAILURE';

// Action Types: Users list data
export const GET_USER_LIST_DATA_REQUEST = 'GET_USER_LIST_DATA_REQUEST';
export const GET_USER_LIST_DATA_SUCCESS = 'GET_USER_LIST_DATA_SUCCESS';
export const GET_USER_LIST_DATA_FAILURE = 'GET_USER_LIST_DATA_FAILURE';

// Action Types: User packages
export const GET_USER_PACKAGE_REQUEST = 'GET_USER_PACKAGE_REQUEST';
export const GET_USER_PACKAGE_SUCCESS = 'GET_USER_PACKAGE_SUCCESS';
export const GET_USER_PACKAGE_FAILURE = 'GET_USER_PACKAGE_FAILURE';

export const GET_USER_PACKAGES_LOG_REQUEST = 'GET_USER_PACKAGES_LOG_REQUEST';
export const GET_USER_PACKAGES_LOG_SUCCESS = 'GET_USER_PACKAGES_LOG_SUCCESS';
export const GET_USER_PACKAGES_LOG_FAILURE = 'GET_USER_PACKAGES_LOG_FAILURE';

// Prompt settings + get user by id
export const GET_USER_BY_ID_REQUEST = 'GET_USER_BY_ID_REQUEST';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const GET_USER_BY_ID_FAILURE = 'GET_USER_BY_ID_FAILURE';

export const SAVE_AGENT_PROMPT_REQUEST = 'SAVE_AGENT_PROMPT_REQUEST';
export const SAVE_AGENT_PROMPT_SUCCESS = 'SAVE_AGENT_PROMPT_SUCCESS';
export const SAVE_AGENT_PROMPT_FAILURE = 'SAVE_AGENT_PROMPT_FAILURE';

// Change Password Action Types
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

// GET: /user/getUsersListForDropdown?company=&page=&limit=
export const getUsersListForDropdown = (company = '', page = 1, limit = 20) => async (dispatch) => {
  dispatch({ type: GET_USERS_DROPDOWN_REQUEST });
  try {
    const response = await api.get('user/getUsersListForDropdown', {
      params: { company, page, limit }
    });

    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_USERS_DROPDOWN_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }

    const message = response?.data?.message || 'Failed to fetch users dropdown list';
    dispatch({ type: GET_USERS_DROPDOWN_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch users dropdown list';
    dispatch({ type: GET_USERS_DROPDOWN_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

export const getUserListData = ({ startDate, endDate, company, email, storeUrl, userId, is_connected_to_brand, shopify_connection, plan, page, limit } = {}) => async (dispatch) => {
  dispatch({ type: GET_USER_LIST_DATA_REQUEST });
  try {
    const payload = { startDate, endDate, company, email, storeUrl, userId, is_connected_to_brand, shopify_connection, plan, page, limit };
    const response = await api.post('user/userListData', payload);

    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_USER_LIST_DATA_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }

    const message = response?.data?.message || 'Failed to fetch user list data';
    dispatch({ type: GET_USER_LIST_DATA_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch user list data';
    dispatch({ type: GET_USER_LIST_DATA_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};



// POST: user/getUserById { userId }
export const getUserById = (userId) => async (dispatch) => {
  dispatch({ type: GET_USER_BY_ID_REQUEST });
  try {
    const response = await api.post('user/getUserById', { userId });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_USER_BY_ID_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to fetch user details';
    dispatch({ type: GET_USER_BY_ID_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch user details';
    dispatch({ type: GET_USER_BY_ID_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

export const saveAgentPrompt = ({ userId, prompt, type = 'simpleprompt' }) => async (dispatch) => {
  dispatch({ type: SAVE_AGENT_PROMPT_REQUEST });
  try {
    const response = await api.post('agent/agentWisePromptSetting', { userId, prompt, type });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: SAVE_AGENT_PROMPT_SUCCESS, payload: response.data });
      if (response?.data?.message) {
        showSuccess(response.data.message);
      }
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to save prompt';
    dispatch({ type: SAVE_AGENT_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to save prompt';
    dispatch({ type: SAVE_AGENT_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

// POST: /api/admin/packages/UserPackage
export const getUserPackage = (userId) => async (dispatch) => {
  dispatch({ type: GET_USER_PACKAGE_REQUEST });
  try {
    const response = await api.post('packages/UserPackage', { userId });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_USER_PACKAGE_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to fetch user package';
    dispatch({ type: GET_USER_PACKAGE_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch user package';
    dispatch({ type: GET_USER_PACKAGE_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

// POST: /api/admin/packages/userPackagesLog
export const getUserPackagesLog = (userId) => async (dispatch) => {
  dispatch({ type: GET_USER_PACKAGES_LOG_REQUEST });
  try {
    const response = await api.post('packages/userPackagesLog', { userId });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_USER_PACKAGES_LOG_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to fetch user packages log';
    dispatch({ type: GET_USER_PACKAGES_LOG_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch user packages log';
    dispatch({ type: GET_USER_PACKAGES_LOG_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

// POST: user/changePassword { userId, password }
export const changePassword = ({ userId, password }) => async (dispatch) => {
  dispatch({ type: CHANGE_PASSWORD_REQUEST });
  try {
    const response = await api.post('user/changePassword', { userId, password });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: CHANGE_PASSWORD_SUCCESS, payload: response.data });
      if (response?.data?.message) {
        showSuccess(response.data.message);
      }
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to change password';
    dispatch({ type: CHANGE_PASSWORD_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to change password';
    dispatch({ type: CHANGE_PASSWORD_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};


